import { an } from 'shared'
import {
  CIMSFormItemProps,
  CustomValidatorOptions,
} from '../../CIMSFormItem/types'

export function useValidateWhitespaceProps({
  label: formItemLabel,
  required,
}: UseValidateWhitespacePropsOptions): Required<
  Pick<CIMSFormItemProps, 'label' | 'validateFirst'>
> &
  Pick<CIMSFormItemProps, 'requiredMessage'> & {
    customValidator: CustomValidatorOptions
  } {
  return {
    validateFirst: 'parallel',
    ...(required
      ? { requiredMessage: `Please enter ${an(formItemLabel.toLowerCase())}` }
      : {}),
    customValidator: {
      message: `${formItemLabel} cannot contain only whitespace`,
      validator: (value) => !value || !!value.trim().length,
    },
    label: formItemLabel,
  }
}

type UseValidateWhitespacePropsOptions = {
  label: string
  required?: true
}
